import { useState } from "react";
import Typography from "@mui/material/Typography";
import {
  ALL_PRODUCTS,
  BUTTON_EDIT,
  PRODUCTS_TO_PROMOTE_PLACEHOLDER,
} from "../../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../../lib/i18next";
import Box from "@mui/material/Box";
import ModalEditProductsConfiguration from "./ModalEditProductsConfiguration";
import { useController } from "react-hook-form";
import { getReactHookFormNestedError } from "../../../../../utils/errors";
import { SUBDIVISION_OPTIONS_GOOGLE } from "../../../../../services/google";
import { INPUT_COLOR, INPUT_COLOR_BORDER } from "../../../../../utils/colors";
import { BORDER_RADIUS } from "../../../../../utils/constants";

const ProductsConfigurationContainerGoogle = ({
  integrationID,
  adAccountID,
  merchantCenterID,
  control,
  name,
  errors,
  disabled,
}) => {
  const {
    field: { onChange, value },
  } = useController({
    control,
    name,
    defaultValue: {
      type: "allProducts",
      subdivision: "",
      children: [],
    },
  });
  const [
    modalEditProductsConfigurationOpen,
    setModalEditProductsConfigurationOpen,
  ] = useState(false);

  const { t } = useTranslationApp();
  const error = getReactHookFormNestedError(errors, name);

  const onToggleEditProductsConfigurationOpen = () =>
    setModalEditProductsConfigurationOpen((prev) => !prev);

  const getText = () => {
    if (!value?.type) return [];

    const children = Array.isArray(value.children) ? value.children : [];

    if (value.type === "allProducts") {
      return [t(ALL_PRODUCTS)];
    }
    if (value.type === "specific") {
      const subdivisionObj = SUBDIVISION_OPTIONS_GOOGLE.find(
        (sub) => sub.value === value.subdivision
      );
      let childrenLabels = children;
      if (subdivisionObj?.translateOptions) {
        const options = subdivisionObj.options ?? [];
        childrenLabels = children.map((val) => {
          const found = options.find((opt) => opt.value === val);
          return found ? t(found.label) : val;
        });
      }
      return childrenLabels.slice(0, 3);
    }
    return [];
  };
  return (
    <Box
      id={name}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
      }}
    >
      <Typography variant="body1" sx={{ mb: 1.5 }}>
        {t(PRODUCTS_TO_PROMOTE_PLACEHOLDER)}
      </Typography>

      <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mb: 3 }}>
        {getText().map((text, index) => (
          <Typography
            key={index}
            variant="body1"
            sx={{
              color: "#fff",
              backgroundColor: INPUT_COLOR,
              border: `1px solid ${INPUT_COLOR_BORDER}`,
              borderRadius: 5,
              padding: "4px 12px",
              display: "inline-block",
            }}
          >
            {text}
          </Typography>
        ))}
      </Box>

      {!disabled && (
        <Typography
          body="caption"
          sx={{
            cursor: "pointer",
            textAlign: "center",
            width: "100%",
            justifyContent: "center",
            p: 1,
            color: "#000",
            border: "1px solid #e1e1e1",
            borderRadius: BORDER_RADIUS,
            "&:hover": {
              color: "#000",
            },
          }}
          onClick={onToggleEditProductsConfigurationOpen}
        >
          {t(BUTTON_EDIT)}
        </Typography>
      )}

      {error?.message && (
        <Typography variant="body2" color="error">
          {error.message}
        </Typography>
      )}

      {modalEditProductsConfigurationOpen && (
        <ModalEditProductsConfiguration
          modalOpen={modalEditProductsConfigurationOpen}
          onCloseModal={onToggleEditProductsConfigurationOpen}
          integrationID={integrationID}
          adAccountID={adAccountID}
          merchantCenterID={merchantCenterID}
          onCallbackSave={(data) => {
            onChange(data);
            onToggleEditProductsConfigurationOpen();
          }}
          initialValues={value}
        />
      )}
    </Box>
  );
};

export default ProductsConfigurationContainerGoogle;
